var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C09E25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.272 13.52-.01 7.38c0 .9.63 1.34 1.41.97l2.68-1.27c.22-.11.59-.11.81 0l2.69 1.27c.77.36 1.41-.07 1.41-.97v-7.56",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#026CCF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 15c3.728 0 6.75-2.91 6.75-6.5S16.478 2 12.75 2 6 4.91 6 8.5 9.022 15 12.75 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#026CCF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.25 8.744 1.662 1.58L15.35 7"
  })));
};
export default SvgMedal;